module.exports = __webpack_public_path__ + "media/images/meat-500a08b15a85c2abcad36e383eac1c06.jpg";